"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
var _material = require("@ori-ui/mui-bundle/material");
var _constants = require("../constants");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-unnecessary-condition -- Wrong typing, ownerState can be null */

const styleOverrides = {
  root: ({
    theme,
    ownerState
  }) => ({
    padding: '10px 15px ',
    [theme.breakpoints.up('sm')]: {
      padding: '10px 30px '
    },
    ...(ownerState?.variant === 'standard' && {
      backgroundColor: _constants.colors.lightItem[ownerState.color ?? ownerState.severity ?? 'info'].background,
      color: _constants.colors.lightItem[ownerState.color ?? ownerState.severity ?? 'info'].textAlert,
      borderColor: _constants.colors.lightItem[ownerState.color ?? ownerState.severity ?? 'info'].background,
      [`& .${_material.alertClasses.icon}`]: {
        color: _constants.colors.lightItem[ownerState.color ?? ownerState.severity ?? 'info'].textAlert
      }
    }),
    ...(ownerState?.color === 'default' && ownerState?.variant === 'filled' && {
      backgroundColor: _constants.colors.defaultColors.main,
      color: _constants.colors.defaultColors.contrastText,
      borderColor: _constants.colors.defaultColors.main
    })
  }),
  filledSuccess: {
    backgroundColor: _constants.colors.success.light,
    color: _constants.colors.text.primary
  },
  message: ({
    theme
  }) => ({
    alignContent: 'center',
    fontSize: theme.typography.body1.fontSize,
    padding: '10px 0'
  }),
  icon: ({
    theme
  }) => ({
    fontSize: '2.4rem',
    lineHeight: 1,
    opacity: '1',
    padding: '7.5px 0',
    marginRight: '10px'
  })
};
const defaultProps = {
  severity: 'info',
  iconMapping: {
    error: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {
      fontSize: "inherit"
    }),
    info: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoCircle, {
      fontSize: "inherit"
    }),
    default: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoCircle, {
      fontSize: "inherit"
    }),
    success: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircle, {
      fontSize: "inherit"
    }),
    warning: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Warning, {
      fontSize: "inherit"
    })
  }
};
var _default = exports.default = {
  defaultProps,
  styleOverrides
};
//# sourceMappingURL=MuiAlert.js.map